<template>
  <div :class="'col-md-' + col.width + ' layout-column'">
    <div class="panel panel-default">
      <div class="panel-heading">
        <span>{{ col.identifier }}</span>
        <span class="pull-right">
          <select class="form-control width-selector" v-model="col.width">
            <option :value="2">2/12</option>
            <option :value="3">3/12</option>
            <option :value="4">4/12</option>
            <option :value="5">5/12</option>
            <option :value="6">6/12</option>
            <option :value="7">7/12</option>
            <option :value="8">8/12</option>
            <option :value="9">9/12</option>
            <option :value="10">10/12</option>
            <option :value="11">11/12</option>
            <option :value="12">12/12</option>
          </select>
        </span>
      </div>
      <div class="panel-body">
        <button type="button" class="btn btn-danger remove-column pull-right" v-on:click="removeColumn(col)"><i class="fa fa-fw fa-trash"></i></button>
        <draggable v-model="myComponents" group="layouteditor" tag="ul" draggable=".cllink" :delay="100" :delayOnTouchOnly="true" :componentData="{ attrs: { class: 'components' }}" v-on:change="componentOrderChanged({ column: col.identifier, components: myComponents }, $event)">
          <li v-for="link in myComponents" class="cllink"><button type="button" class="btn btn-default component-button remove-component" v-on:click="removeComponent(link)">{{ link.component.name }} <i class="fa fa-fw fa-close"></i></button></li>
        </draggable>
        <!--
        <ul class="components">
          <li v-for="link in layout.ownComponent_layout.filter(l => l.column === col.identifier)">
            <button type="button" class="btn btn-default remove-component" v-on:click="removeComponent(link)">{{ link.component.name }} <i class="fa fa-fw fa-close"></i></button>
            <br />
          </li>
        </ul>
        <br />
        //-->
        <button type="button" class="btn btn-info add-component" v-on:click="addComponentDialog(col)"><i class="fa fa-fw fa-plus"></i> {{ _('Add component') }}</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      myComponents: []
    }
  },
  props: ['col', 'components'],
  methods: {
    componentOrderChanged (identifier, event) {
      this.$emit('componentOrderChanged', identifier, event)
    },
    removeColumn (col) {
      this.$emit('removeColumn', col)
    },
    removeComponent (link) {
      this.$emit('removeComponent', link)
    },
    addComponentDialog (col) {
      this.$emit('addComponentDialog', col)
    }
  },
  created () {
    if (this.components) {
      this.myComponents = [...this.components]
    } else {
      this.myComponents = []
    }
  },
  watch: {
    components: {
      deep: true,
      handler (newValue) {
        if (newValue) {
          this.myComponents = [...newValue]
        } else {
          this.myComponents = []
        }
      }
    }
  }
}
</script>

<style scoped>
ul.components, ul.components li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.component-button {
  display: block;
}
</style>